module.exports = __webpack_public_path__ + "static/media/city_sightseeing_nyiregy.ee178b5d.png";